/** 预览态全页水印（对齐 PC 端 usePreviewWatermark，适配 H5 窄屏） */

const WATERMARK_ID = "preview-watermark";

/**
 * 用 canvas 绘制多行水印并铺满页面。
 * 瓦片略大于文字区，保证旋转后不裁切、平铺间距适中。
 * @param {string[]} lines 水印文案行
 * @returns {string} 水印 DOM id
 */
function setWatermark(lines) {
  const existing = document.getElementById(WATERMARK_ID);
  if (existing && existing.parentNode) {
    existing.parentNode.removeChild(existing);
  }

  // H5：缩小瓦片间距，保证一屏至少可见 2 个水印
  const tileWidth = 200;
  const tileHeight = 140;
  const fontSize = 12;
  const lineHeight = 18;
  const rotateDeg = -22;

  const can = document.createElement("canvas");
  can.width = tileWidth;
  can.height = tileHeight;

  const cans = can.getContext("2d");
  cans.save();
  cans.translate(tileWidth / 2, tileHeight / 2);
  cans.rotate((rotateDeg * Math.PI) / 180);
  cans.font = fontSize + "px sans-serif";
  cans.fillStyle = "#333333";
  cans.textAlign = "center";
  cans.textBaseline = "middle";
  cans.globalAlpha = 1;

  const startY = -((lines.length - 1) * lineHeight) / 2;
  lines.forEach((line, index) => {
    cans.fillText(String(line || ""), 0, startY + index * lineHeight);
  });
  cans.restore();

  const div = document.createElement("div");
  div.id = WATERMARK_ID;
  div.style.cssText = [
    "pointer-events:none",
    "position:fixed",
    "inset:0",
    "z-index:9999",
    "width:100%",
    "height:100%",
    "opacity:0.18",
    "background-image:url(" + can.toDataURL("image/png") + ")",
    "background-repeat:repeat",
    "background-position:20px 30px",
    "background-size:" + tileWidth + "px " + tileHeight + "px",
  ].join(";");
  document.body.appendChild(div);
  return WATERMARK_ID;
}

/**
 * 添加/更新预览水印。
 * @param {...string} texts 水印文案（多行）
 */
export const setWaterMark = (...texts) => {
  const lines = texts.length
    ? texts.map((t) => String(t ?? ""))
    : ["仅供预览，非正式稿件"];
  let id = setWatermark(lines);
  if (document.getElementById(id) === null) {
    setWatermark(lines);
  }
};

/**
 * 移除预览水印。
 */
export const removeWatermark = () => {
  const el = document.getElementById(WATERMARK_ID);
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
};
